export function isEmpty(value: unknown): boolean {
  if (Array.isArray(value) || typeof value === 'string') {
    return value.length === 0;
  }

  if (value instanceof Uint8Array) {
    return value.length === 0;
  }

  if (value instanceof Set || value instanceof Map) {
    return value.size === 0;
  }

  if (value && typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
}
